import { Endpoints } from '@/constants';
import { store } from '@/store/store';

import { ymsAdminClient } from './taskService';

import type { NotificationResponseDTO } from '@/types';

function getNotificationFunctionCode(): string {
  return store.getState().global.middlewareFunctionCodes?.notifications ?? '';
}

function getOrgId(): string {
  return String(store.getState().user.plant?.org_id ?? '');
}

function getAccessToken(): string {
  return store.getState().user.accessToken ?? '';
}

export async function getNotifications(
  limit = 20,
  filterBy = 'All'
): Promise<NotificationResponseDTO[]> {
  const functionCode = getNotificationFunctionCode();
  const orgId = getOrgId();
  const accessToken = getAccessToken();

  if (!functionCode || !orgId || !accessToken) {
    throw new Error('Missing notification params: functionCode, orgId, or accessToken');
  }

  const url = `${Endpoints.NotificationList}${functionCode}&plant_id=${orgId}&limit=${String(limit)}&filterBy=${filterBy}`;

  const response = await ymsAdminClient.get<NotificationResponseDTO[]>(url, {
    headers: {
      'access-Token': accessToken,
    },
  });

  return response.data;
}
